import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getStorageList = createAsyncThunk("centraliseStorage/getStorageList", async () => {
  try {
    const response = await magnifiAPI.getStorageList();

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const createStorageList = createAsyncThunk("centraliseStorage/createStorageList", async (payload) => {
  try {
    const response = await magnifiAPI.createStorageList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const validateStorage = createAsyncThunk("centraliseStorage/validateStorage", async (payload) => {
  try {
    const response = await magnifiAPI.validateStorage(payload);

    return response.data;
  } catch (error) {
    console.error(error);
  }
});

export const editStorageList = createAsyncThunk("centraliseStorage/editStorageList", async (payload) => {
  try {
    const response = await magnifiAPI.editStorageList(payload);

    return response.data;
  } catch (error) {
    console.error(error);
  }
});
